import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { ExposedReadMortgageEligibilityConfigRes } from 'app/interfaces/responses/Exposed/exposedReadMortgageEligibilityConfigRes';
import { MortgageEligibilityInfoService } from 'app/services/api/mortgageEligibilityInfo/mortgageEligibilitInfo.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MortgageEligibilityConfigResolver implements Resolve<ExposedReadMortgageEligibilityConfigRes> {
    constructor(private mortgageEligibilityInfoService: MortgageEligibilityInfoService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<ExposedReadMortgageEligibilityConfigRes> {
        return this.mortgageEligibilityInfoService.getMortgageEligibilityConfig();
    }
}
